import {
    SET_GAME,
    SET_SPIN_READY, SET_SPIN_NOT_READY,
    RECEIVED_GIFT_POPUP, CLEAN_RECEIVED_GIFT,
    WINNERS_POPUP,
    GIFTSLIST_POPUP,
    RECIVED_GIFT,
    ADD_WHEEL_WINNERS, ADD_SHOP_WINNERS,
    WHEEL_PAGINATION, SHOP_PAGINATION,
    ALL_WHEEL_WINNERS, ALL_SHOP_WINNERS,
    WHEEL_ANIMATION, WHEEL_DEG,
    SET_SELECTED_GIFT,
    SHOP_WINNERS_POPUP,
    SET_REMAIN_POINTS,
    RECEIVED_SHOP_GIFT_POPUP,
    CLEAN_RECEIVED_SHOP_GIFT,
    RECIVED_SHOP_GIFT,
    SET_SHOP_GIFTS
} from "./types";

const gameExample = {
    settings: null,
    gifts: [],
    winners: [],
}
const receivedGiftExample = {
    id: 0,
    giftId: 0,
    name: '',
    image: '',
    subscriber: '',
    createdAt: '',
    type: null,
    points: 0,
}
const paginationExample = {
    total: null,
    count: null,
    perPage: null,
    currentPage: null,
    lastPage: null,
    nextPageUrl: null
}
const initialState = {
    //settings: settingsExample,
    gameWheel: gameExample,
    gameShop: gameExample,
    spinReady: false,
    receivedGiftPopup: null,
    receivedShopGiftPopup: null,
    giftsListPopup: null,
    winnersPopup: null,
    shopWinnersPopup: null,
    receivedGift: receivedGiftExample,
    receivedShopGift: receivedGiftExample,
    allWinners: false,
    shopAllWinners: false,
    pagination: paginationExample,
    shopPagination: paginationExample,
    wheelAnimation: null,
    wheelDeg: 0,
    winnersStats: {
        count: 0,
        page: 0
    },
    remainPoints: null,
}

export const gameReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GAME:
            return {
                ...state,
                gameWheel: action.gameWheel,
                gameShop: action.gameShop
            }
        case SET_SPIN_READY:
            return {
                ...state,
                spinReady: true
            }
        case SET_SPIN_NOT_READY:
            return {
                ...state,
                spinReady: false
            }
        case RECEIVED_GIFT_POPUP:
            return {
                ...state,
                receivedGiftPopup: action.payload
            }
        case RECIVED_GIFT:
            return {
                ...state,
                receivedGift: action.payload
            }
        case CLEAN_RECEIVED_GIFT:
            return {
                ...state,
                receivedGift: receivedGiftExample,
            }
        case RECEIVED_SHOP_GIFT_POPUP:
            return {
                ...state,
                receivedShopGiftPopup: action.payload
            }
        case RECIVED_SHOP_GIFT:
            return {
                ...state,
                receivedShopGift: action.payload
            }
        case CLEAN_RECEIVED_SHOP_GIFT:
            return {
                ...state,
                receivedShopGift: receivedGiftExample,
            }
        case WINNERS_POPUP:
            return {
                ...state,
                winnersPopup: action.payload
            }
        case SHOP_WINNERS_POPUP:
            return {
                ...state,
                shopWinnersPopup: action.payload
            }
        case GIFTSLIST_POPUP:
            return {
                ...state,
                giftsListPopup: action.payload
            }
        case ADD_WHEEL_WINNERS:
            return {
                ...state,
                gameWheel: {
                    ...state.gameWheel,
                    winners: [...action.winners, ...action.payload]
                }
            }
        case ADD_SHOP_WINNERS:
            return {
                ...state,
                gameShop: {
                    ...state.gameShop,
                    winners: [...action.winners, ...action.payload]
                }
            }
        case WHEEL_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }
        case SHOP_PAGINATION:
            return {
                ...state,
                shopPagination: action.payload
            }
        case ALL_WHEEL_WINNERS:
            return {
                ...state,
                allWinners: action.payload
            }
        case ALL_SHOP_WINNERS:
            return {
                ...state,
                allShopWinners: action.payload
            }
        case WHEEL_ANIMATION:
            return {
                ...state,
                wheelAnimation: action.payload
            }
        case WHEEL_DEG:
            return {
                ...state,
                wheelDeg: action.payload
            }
        case SET_SELECTED_GIFT:
            return {
                ...state,
                selectedGift: action.payload
            }
        case SET_REMAIN_POINTS:
            return {
                ...state,
                remainPoints: action.payload
            }
        case SET_SHOP_GIFTS:
            return {
                ...state,
                gameShop: {
                    ...state.gameShop,
                    gifts: action.payload
                }
            }
        default:
            return state
    }
}